import { Component, inject } from '@angular/core';
import { InternalRoadService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  InternalRoadCreateDto,
  InternalRoadDto,
  InternalRoadExcelDownloadDto,
  InternalRoadUpdateDto,
} from '../proxy/planning/dtos/internal-road';
import { INTERNALROAD_CONFIG, INTERNALROAD_FIELDS } from './internal-road.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-internal-road',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, InternalRoadService, ConfirmationService],
  templateUrl: './internal-road.html',
  styleUrl: './internal-road.scss',
})
export class InternalRoad extends BaseHierarchicalCrudComponent<
  InternalRoadDto,
  InternalRoadCreateDto,
  InternalRoadUpdateDto,
  InternalRoadExcelDownloadDto
> {
  service = inject(InternalRoadService);
  config = INTERNALROAD_CONFIG;
  fields = INTERNALROAD_FIELDS;

  protected prepareUpdateDto(data: any, selected: InternalRoadDto): InternalRoadUpdateDto {
    return {
      name: data.name,
      locationId: data.locationId,
      propertyId: data.propertyId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'InternalRoad';
  }
}
